export default __webpack_public_path__ + "static/media/3-sgi-home-v2.7d65d692.png";